import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CustomvalidationService } from 'src/app/services/customvalidation.service';
import { environment } from '../../../../../environments/environment.prod';
@Component({
  selector: 'app-doctor-confirmpassword',
  templateUrl: './doctor-confirmpassword.component.html',
  styleUrls: ['./doctor-confirmpassword.component.scss']
})
export class DoctorConfirmpasswordComponent implements OnInit {
  loginform: FormGroup;
  // customValidator: any;
  otp: any;
  id: any;
  phoneNumber: any;
  newPassword: any;
  confirmPassword: any;
  customConditionIsTrue: boolean = false; 
  phide = true;
  hide = true;
  constructor(@Inject(MAT_DIALOG_DATA) private _data: any,private fb: FormBuilder,private customValidator: CustomvalidationService,  private router: Router,private Http: HttpClient, private notify: ToastrService, private matinput: MatInputModule, private matfield: MatFormFieldModule) {
    this.loginform = this.fb.group({
      'otp':[''],
      'phoneNumber': [''],
      'newPassword': ['', Validators.compose([Validators.required, 
        this.customValidator.patternValidator(new RegExp(/[^A-Za-z0-9]/), { hasNonAlphanum: true }),
        this.customValidator.patternValidator(new RegExp(/[A-Z]/), { hasCapitalCase: true }),
        this.customValidator.patternValidator(new RegExp(/[a-z]/), { hasSmallCase: true }),
        Validators.minLength(8)
     ])],
     'id':[0],
      'confirmPassword': ['', [Validators.required]],
      'user_type': [''],
     },
     );
   }

  ngOnInit(): void {
    this.bind()
    console.log('2nd data', this._data)
  }
  onSubmit() {
    this._data.otp = this.otp;
    this._data.id = this.id;
    this._data.phoneNumber = this.phoneNumber;
    this._data.newPassword = this.newPassword;
    this._data.confirmPassword = this.confirmPassword;

    /*
    var resetPwdData = {
      otp: this.loginform.value.otp,
      id: this._data.id,
      phoneNumber: this.loginform.value.phoneNumber,
      newPassword: this.loginform.value.newPassword,
      confirmPassword: this.loginform.value.confirmPassword,
      user_type : "doctor"

    }
    */

    if (!this.loginform.value.newPassword || !this.loginform.value.confirmPassword) {
      this.notify.error('Please enter the New password & Confirm password.', 'Error');
      return;
    }
    console.log('password reset data :' + JSON.stringify(this.loginform.value))
    this.Http.post(`${environment.Login_URL}` + `api/Authentication/ResetPassword_Online`, this.loginform.value).subscribe((data:any) => {
    this.notify.success("Password has changed successfully.");
    location.reload();     
    })
}

bind(){
console.log('2nd bind', this._data)
this.loginform.controls['otp'].setValue(this._data.otp)
this.loginform.controls['phoneNumber'].setValue(this._data.phoneNumber)
this.loginform.controls['newPassword'].setValue(this._data.newPassword)
this.loginform.controls['confirmPassword'].setValue(this._data.confirmPassword)
this.loginform.controls['id'].setValue(this._data.id)
this.loginform.controls['user_type'].setValue("doctor")
}
}
